<template>
  <footer class="no-internal-print">
    <b-row class="footer__wrapper" align-content="center">
      <b-col
        class="footer__username"
        md="4">
        <span class="material-icons footer__user-icon">person</span>
        {{ this.username }}
      </b-col>
      <b-col
        class="text-center"
        md="4">
        <img
          alt="ecm logo"
          class="footer__ecm-logo"
          src="/static/imgs/sigma-ecm-logo.svg"
        >
        <span class="footer__powered-by">powered by</span>
        <img
          alt="treetech logo"
          class="footer__treetech-logo"
          src="/static/imgs/footer-treetech-logo.svg"
        >
        <span class="footer__company-name">Treetech Tecnologia</span>
      </b-col>
      <b-col
        class="text-right"
        md="4">
        <real-time-clock class="footer__clock"/>
      </b-col>
    </b-row>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'sFooter',
  computed: {
    ...mapGetters(['user']),
    username() {
      return this.user?.username;
    },
  },
};
</script>

<style scoped lang="sass">
@import "src/styles/defaults/mobile-first"

.footer
  &__wrapper
    justify-content: space-between
    align-items: center
    flex-wrap: wrap
    overflow: hidden
    background-color: var(--color-primary)
    color: var(--color-white-100)
    padding: .3rem 0
    font-size: .9rem
    margin: 0
    height: 100%

    +media-max-sm()
      display: none

  &__username
    display: flex
    align-items: center
    text-transform: uppercase

  &__user-icon
    font-size: 1.35rem
    margin-right: .2rem

  &__version
    text-align: center
    opacity: .9

  &__clock
    opacity: .9

  &__powered-by
    font-size: .75rem
    padding: 0 .4rem
    font-weight: normal
    opacity: .9

  &__ecm-logo
    height: 1.3rem

  &__company-name
    font-weight: normal
    margin-left: 0.3rem

  &__treetech-logo
    height: 1.2rem
</style>
